<div
    class="flex flex-col justify-start gap-2 items-start sm:flex-row mb-5"
    *transloco="let tAddRecordContent; read: 'add_record_content'"
>
    <div class="w-full sm:w-1/2 flex flex-col gap-2">
        @if (pickedWorkspaces().length === 1) {
            <ng-container
                *ngTemplateOutlet="
                    settingsItem;
                    context: {
                        name: tAddRecordContent('workspace'),
                        icon: pickedWorkspaces()[0].icon.value,
                        selectedName: pickedWorkspaces()[0].name.value,
                        color: pickedWorkspaces()[0].color.value,
                    }
                "
            ></ng-container>
        } @else if (pickedWorkspaces().length === 2) {
            <ng-container
                *ngTemplateOutlet="
                    settingsItem;
                    context: {
                        name: tAddRecordContent('workspace'),
                        icon: workspacesWithoutGlobal[0].icon.value,
                        selectedName: workspacesWithoutGlobal[0].name.value,
                        color: workspacesWithoutGlobal[0].color.value,
                        globalIcon: globalWorkspace.icon.value,
                        globalColor: globalWorkspace.color.value,
                    }
                "
            ></ng-container>
        } @else {
            <div
                (click)="openDialog()"
                class="bg-neutral2 rounded-lg px-2 py-1 cursor-pointer recordInfoBlock"
            >
                <div class="flex items-center justify-between w-full mb-1">
                    <div class="text-textLight caption-1">
                        {{ tAddRecordContent('workspace') }}
                    </div>
                    <app-tb-icon
                        icon="custom_edit"
                        class="text-textLight icon-d editIcon"
                    ></app-tb-icon>
                </div>
                <div class="w-full flex items-center">
                    <app-tb-icon
                        [icon]="globalWorkspace.icon.value"
                        class="icon-d"
                        [color]="globalWorkspace.color.value"
                        [style.color]="globalWorkspace.color.value"
                    ></app-tb-icon>
                    <div class="w-[1px] h-[1.5rem] bg-neutral3 mx-1"></div>
                    <div
                        [appTruncateIcons]="workspacesWithoutGlobal.length"
                        #counter="counter"
                        class="flex flex-row overflow-hidden w-full"
                    >
                        @for (workspace of workspacesWithoutGlobal; track workspace.guid) {
                            <app-tb-icon
                                [icon]="workspace.icon.value"
                                class="icon-d"
                                [style.color]="workspace.color.value"
                            ></app-tb-icon>
                        }
                        @if (counter.counter; as counter) {
                            <app-tb-counter class="body-1" [counter]="counter"></app-tb-counter>
                        }
                    </div>
                </div>
            </div>
        }

        <ng-container *appEnv="'prod'; visible: false">
            <ng-container
                *ngTemplateOutlet="
                    settingsItem;
                    context: {
                        name: tAddRecordContent('template'),
                        icon: 'person_outline',
                        selectedName: '$Test',
                    }
                "
            ></ng-container>
        </ng-container>
    </div>

    <div
        *transloco="let tSchemaReadableName; read: 'nav_menu'"
        class="w-full sm:w-1/2 flex flex-col gap-2"
    >
        <ng-container
            *ngTemplateOutlet="
                settingsItem;
                context: {
                    name: tAddRecordContent('type'),
                    icon: schemaIconByName[selectedSchema().name],
                    selectedName: tSchemaReadableName(selectedSchema().name),
                    color: 'primary',
                }
            "
        ></ng-container>

        <!-- will be changed after ACL implementation -->
        <ng-container *appEnv="'prod'; visible: false">
            <ng-container
                *ngTemplateOutlet="
                    settingsItem;
                    context: {
                        name: tAddRecordContent('access'),
                        icon: 'person_outline',
                        selectedName: '$Everyone',
                    }
                "
            ></ng-container>
        </ng-container>
    </div>
</div>

<ng-template
    #settingsItem
    let-icon="icon"
    let-name="name"
    let-color="color"
    let-selectedName="selectedName"
    let-globalIcon="globalIcon"
    let-globalColor="globalColor"
>
    <div
        (click)="openDialog()"
        class="bg-neutral2 rounded-lg px-2 py-1 cursor-pointer recordInfoBlock"
    >
        <div class="flex items-center justify-between w-full mb-1">
            <div class="text-textLight caption-1">{{ name }}</div>
            <app-tb-icon icon="custom_edit" class="text-textLight icon-d editIcon"></app-tb-icon>
        </div>
        <div class="flex">
            @if (globalIcon) {
                <app-tb-icon
                    [icon]="globalIcon"
                    class="icon-d"
                    [color]="globalColor"
                    [style.color]="globalColor"
                ></app-tb-icon>
                <div class="w-[1px] h-[1.5rem] bg-neutral3 mx-1"></div>
            }
            <app-tb-icon
                [icon]="icon"
                class="mr-2 icon-d"
                [color]="color"
                [style.color]="color"
            ></app-tb-icon>
            <div class="body-1 truncate">{{ selectedName }}</div>
        </div>
    </div>
</ng-template>
